










































































import { Component } from 'vue-property-decorator';
import { AbstractProductWidget } from '@/views/product/widgets/AbstractProductWidget';
import ProductImage from '@/views/product/common/ProductImage.vue';
import ProductTitle from '@/views/product/common/ProductTitle.vue';
import Routes from '@/util/Routes';
import { Urls } from '@/util/Urls';
import { ProductPropertyDto } from '@/api';
import OfferBadge from '@/views/product/common/OfferBadge.vue';
import { getModule } from 'vuex-module-decorators';
import SearchBarStore from '@/stores/search/searchBar.store';
import KeycloakStore from '@/stores/user/keycloak.store';

@Component({
  components: {
    ProductImage,
    ProductTitle,
    OfferBadge,
  },
})
export default class BrowseProduct extends AbstractProductWidget {
  private searchBarStore = getModule(SearchBarStore, this.$store);
  private keycloakStore = getModule(KeycloakStore, this.$store);
  private showPopup = false;

  get isLoggedIn(): boolean {
    return this.keycloakStore.authenticated;
  }

  public hideSearchSuggestions() {
    this.searchBarStore.setSearchBarActive(false);
  }

  private goToDetailPage() {
    this.hideSearchSuggestions();
    this.$emit('productSelect', this.product);
    this.$route.meta.currentScroll = window.scrollY;
    this.$router.push({
      name: Routes.ProductDetail,
      params: {
        sku: this.product.product.sku,
        unitAbbreviation: this.product.unit.abbreviation,
        urlName: Urls.toLinkFriendlyString(this.product.product.name),
      },
    });
  }

  get remainingProperties() {
    if (this.product.product.properties) {
      return this.product.product.properties.filter((x) =>
        ![ProductPropertyDto.NEW, ProductPropertyDto.BIO, ProductPropertyDto.UNSEREKOSTBARKEITEN,
          ProductPropertyDto.ASC, ProductPropertyDto.MSC, ProductPropertyDto.DAUERTIEFPREIS]
          .includes(x));
    }
    return [];
  }

  get mobileProperties() {
    if (this.product.product.properties) {
      return this.product.product.properties.filter(
        (x) => ![ProductPropertyDto.NEW, ProductPropertyDto.BIO,
          ProductPropertyDto.UNSEREKOSTBARKEITEN, ProductPropertyDto.DAUERTIEFPREIS].includes(x),
      );
    }
    return [];
  }
}
